import PropTypes from 'prop-types'
import React from 'react'
import { getFormValues, change } from 'redux-form'
import { connect } from 'react-redux'

export class HidePhoneBtn extends React.PureComponent {
  onClick = () => {
    this.props.change('update', `phones[${this.props.index}].visible`, this.props.isHidden)
  }

  render () {
    const { disabled } = this.props
    return <img className={`form-telefon__hideBtn ${this.props.isHidden ? `form-telefon__hideBtn-hidden` : ``}`}
      onClick={disabled && !this.props.isHidden ? null : this.onClick} src={this.props.isHidden ? '/icons/nevidljiv.svg' : '/icons/vidljiv.svg'}
      width='14' />
    // <i
    //   className={`ico-info-popup ico form-telefon__hideBtn ${this.props.isHidden ? `form-telefon__hideBtn-hidden` : ``}`}
    //   onClick={this.onClick}
    // />
  }
}

const mapStateToProps = (state, ownProps) => {
  const props = {isHidden: false}
  const values = getFormValues('update')(state)
  if (values.phones && Array.isArray(values.phones)) {
    const searchedPhone = values.phones.filter((item, index) => index === ownProps.index)
    if (searchedPhone.length) {
      props.isHidden = searchedPhone[0] && !searchedPhone[0].visible
    }
  }
  return props
}

HidePhoneBtn.propTypes = {
  change: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  isHidden: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired
}

HidePhoneBtn.defaultProps = {
  index: 0,
  isHidden: false
}

export default connect(mapStateToProps, {change})(HidePhoneBtn)
